import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { fetchUsers, registerUser, type User, type RegisterUserIn } from '../api/usersApi';

export function useUsers() {
  const qc = useQueryClient();

  const list = useQuery<User[], Error>({
    queryKey : ['system','users'],
    queryFn  : () => fetchUsers(),
    staleTime: 60_000,
  });

  const create = useMutation({
    mutationFn : (p: RegisterUserIn) => registerUser(p),
    onSuccess  : () => qc.invalidateQueries({ queryKey: ['system','users'] }),
  });

  return { ...list, create };
}
